import { ChevronLeft, Receipt, Wallet } from 'lucide-preact'
import { text } from '#contract'
import type { LocalizedText } from '#contract'
import { useView } from '../../../app/use-view.ts'
import { useT } from '../../../i18n/index.ts'
import { useShop } from './shop-context.ts'
import styles from './shop.module.css'

/**
 * The home page's bar in the skin's colours: its brand, the balance, the orders button (with
 * how many of this shop's orders are under way) and the skin's headline under them.
 */
export function ShopHeader() {
  const t = useT()
  const { skin, vendor, wallet, money, nav } = useShop()
  const orders = useView((view) => view.shops.orders)
  const active = orders.filter((order) => order.vendor === vendor.id).length
  const Brand = skin.brand
  const balance = money(wallet.cents)
  return (
    <header class={styles.bar}>
      <Brand vendor={vendor} />
      <span class={styles.balance} aria-label={t(text('shop.balance', { money: balance }))}>
        <Wallet aria-hidden="true" />
        {balance}
      </span>
      <button
        type="button"
        class={styles.round}
        aria-label={t(text('shop.orders'))}
        onClick={() => {
          nav.push({ kind: 'orders' })
        }}
      >
        <Receipt aria-hidden="true" />
        {active > 0 && (
          <span class={styles.badge} aria-hidden="true">
            {active}
          </span>
        )}
      </button>
      {skin.headline && <p class={styles.headline}>{t(skin.headline)}</p>}
    </header>
  )
}

/** A page's bar: back (the stack's pop), the page's title centred. */
export function PageBar({ title }: { readonly title: LocalizedText }) {
  const t = useT()
  const { nav } = useShop()
  return (
    <header class={styles.bar}>
      <button
        type="button"
        class={[styles.round, styles.back].join(' ')}
        aria-label={t(text('shop.back'))}
        onClick={() => {
          nav.pop()
        }}
      >
        <ChevronLeft aria-hidden="true" />
      </button>
      <h1 class={styles.title}>{t(title)}</h1>
    </header>
  )
}
